/* jld 6.10.2026: desktop mega menus open on hover (mouse/pen only), close when the pointer leaves; click still works (touch, keyboard untouched). */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var OPEN_DELAY = 90, CLOSE_DELAY = 220;
  function init() {
    var menus = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu'));
    if (!menus.length) return;
    menus.forEach(function (hm) {
      var d = hm.querySelector('details'), s = d && d.querySelector('summary');
      if (!d || !s) return;
      var tOpen = null, tClose = null, byHover = false;
      function closeOthers() {
        menus.forEach(function (o) {
          if (o === hm) return;
          var od = o.querySelector('details');
          if (od && od.open) { od.open = false; var os = od.querySelector('summary'); if (os) os.setAttribute('aria-expanded', 'false'); }
        });
      }
      function open() {
        if (!mq.matches) return;
        closeOthers();
        if (!d.open) { byHover = true; d.open = true; }
        s.setAttribute('aria-expanded', 'true');
      }
      function close() {
        if (d.open) { d.open = false; s.setAttribute('aria-expanded', 'false'); }
        byHover = false;
      }
      hm.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch' || !mq.matches) return;
        clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(open, OPEN_DELAY);
      });
      hm.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'touch' || !mq.matches) return;
        clearTimeout(tOpen); clearTimeout(tClose); tClose = setTimeout(close, CLOSE_DELAY);
      });
      /* a click on a label that is already open by hover keeps the panel open instead of toggling it shut */
      s.addEventListener('click', function (e) {
        if (mq.matches && d.open && byHover) e.preventDefault();
      });
      d.addEventListener('toggle', function () { if (!d.open) byHover = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
